const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** Display form of a date-column cell: "2026-10-08" -> "08 Oct 2026". Display only — the stored value (and the
 *  date input / export) stay ISO. Anything that is not a real YYYY-MM-DD date (a blank, or free text that came in
 *  through an import/paste) is returned untouched. Parsed by hand, not via `Date`, so there is no timezone shift. */
export function formatSheetDate(value: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
  if (!m) return value;
  const [, y, mo, d] = m;
  const month = Number(mo);
  const day = Number(d);
  if (month < 1 || month > 12 || day < 1 || day > new Date(Number(y), month, 0).getDate()) return value;
  return `${d} ${MONTHS[month - 1]} ${y}`;
}
